import { Col } from 'antd';
import React, { ReactElement } from 'react';
import { DatePickerLabelProps } from '../../interfaces/newAdmissionInterface';

const DatePickerLabel = ({ dateDifference, payer, isInitialDischargePayer }: DatePickerLabelProps): ReactElement => {
  const { shortName } = payer || {};

  return (
    <Col className={`daycare-info-text display-flex-item align-self-center ${isInitialDischargePayer ? 'width-85' : ''}`}>
      {dateDifference === 0 ? (
        <span className="Daycare-label-text align-center display-flex-item">
          Total LOS :&nbsp;
          <b className="Daycare-label-text align-center display-flex-item">
            {dateDifference} Days
          </b>
        </span>
      ) : dateDifference === 1 ? (
        isInitialDischargePayer ?
          <Col className="display-flex-column align-center ml_13">
            <b className="Daycare-label-text align-center display-flex-item date-picker-label-small">Daycare</b>
            <b className="information-font Daycare-label-text align-center display-flex-item date-picker-label-italic">
              {shortName} Express Discharge
            </b>
          </Col> :
          <b className="Daycare-label-text align-center display-flex-item">Daycare</b>
      ) : (
        <span className="Daycare-label-text align-center display-flex-item">
          <b className="Daycare-label-text align-center display-flex-item">Inpatient</b>
          &nbsp;| Total LOS :&nbsp;
          <b className="Daycare-label-text align-center display-flex-item">
            {dateDifference} Days
          </b>
        </span>
      )}
    </Col>
  );
};

export default DatePickerLabel;
